import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { Trans, useTranslation } from 'react-i18next'
import { EstateAgentBasicInfoDTO } from 'types'

interface Props {
  open: boolean
  isLoading: boolean
  onClose: () => void
  onSubmit?: () => void
  agent?: EstateAgentBasicInfoDTO
}
export default function DeleteDialog(props: Props) {
  const { t } = useTranslation()
  const { open, isLoading, onClose, agent, onSubmit } = props

  return (
    <>
      <Dialog
        fullWidth
        maxWidth={'sm'}
        open={open}
        onClose={onClose}
        PaperProps={{ sx: { py: 2 } }}
      >
        <DialogTitle color="error">
          {t('tables.agents.dialog.delete.title')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Trans
              i18nKey="tables.agents.dialog.delete.content"
              values={{ agentName: agent?.companyTitle }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-evenly' }}>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{ textTransform: 'none', minWidth: '20ch' }}
            disabled={isLoading}
          >
            <Trans i18nKey="tables.agents.dialog.delete.actions.cancel" />
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onSubmit}
            disabled={isLoading}
            sx={{ textTransform: 'none', minWidth: '20ch' }}
          >
            {t('tables.agents.dialog.delete.actions.submit')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
